module.exports = __webpack_public_path__ + "img/month_12_icon.5a2a7da6.png";